<template lang="pug">
    v-card
        v-card-title {{ crew.name }}
        v-card-text
            p {{ crew.email }}
            v-data-table.mx-4(
            :items="crew.serviceReminders",
            :headers="headers",
            dense
            )
            v-dialog(v-model="dialog", max-width="360")
              template(v-slot:activator="{ on }")
                v-btn(v-on="on", color="primary")
                  v-icon mdi-plus
                  | Add Reminder
              v-card
                v-card-title Add Reminder
                v-card-text 
                    div.text-h5 {{crew.name}}
                    v-select(v-model="plate" :items="crew.plates" label="Registration Plate")
                    v-select(v-model="type" :items="items" label="Reminder Type")
                    v-date-picker(v-model="picker" :min="minDate")  
                    v-btn(color="primary" @click="saveReminder") Save
 
</template>

<script>
export default {
    props: ["crew"],
    data() {
        return {
            dialog: false,
            picker: null,
            type: "",
            plate: "",
            items: ["WoF", "Service", "Firmware Update", "Registration", "Insurance", "Other"],
            minDate: new Date().toISOString().slice(0, 10),
   
      headers: [
        { text: "Plate", value: "plate" },
        { text: "Type",  value: "type" },
        { text: "Date", value: "date" },
      ]
            
        }
    },
    computed: {
        reminders() {
           return this.crew.serviceReminders; 
        }
    },
    methods: {
        saveReminder() {
            let data = {
                userID: this.crew.id,
                plate: this.plate,
                type: this.type,
                date: this.picker
            };
            console.log(this.crew);
            console.log(data);
            this.crew.serviceReminders.push(data);
            this.$dealer.createReminder(data);
            this.dialog = false;
            this.type = "";
            this.picker = null;

        }
    }
}
</script>